<template>
  <div class="card p-4">
    <div class="flex-fill text-center">
      <img src="@/assets/img/logo_nextgen.png" class="h-80px" />
      <h1>Obrigado por sua participação</h1>
      <h5>Sua resposta foi registrada com sucesso</h5>
      <router-link to="/" class="btn btn-primary w-50" title="OK">
        OK
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thanks',
}
</script>
